<template lang="pug">
aside
  LabelledValue(label="Publication" :value="issue.publication.name")
  LabelledValue(label="Subsite" :value="issue.subsite.name" v-if="issue.subsite")
  LabelledValue(label="Slug" :value="issue.slug")
  LabelledValue(label="Publish date" :value="issue.publish_on")
  LabelledEditableValue(
    label="Notes" 
    v-model="issue.notes" 
    :multi-line="true" 
    @blur="save"
    :display-formatter="formatNotes"
  )</template>

<script>
  import { mapStores, mapState } from 'pinia'
  import { useIssueStore } from '@/stores/issue'

  import LabelledValue from '@/components/shared/labelled_value.vue'
  import LabelledEditableValue from '@/components/shared/labelled_editable_value.vue'

  export default {
    components: {
      LabelledValue,
      LabelledEditableValue
    },

    computed: {
      ...mapStores(useIssueStore),
      ...mapState(useIssueStore, ['issue'])
    },

    methods: {
      save() {
        this.issueStore.update()
      },
      
      formatNotes(text) {
        return text ? text.replace(/\n/g, '<br />') : '';
      }
    }
  }
</script>
